module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "account-ds"
  }, [_c('div', {
    staticClass: "bar bar-nav account-top-m"
  }, [_c('router-link', {
    staticClass: "button button-link button-nav pull-left",
    attrs: {
      "to": "/customer/account/index"
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  })]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("message.edit_account")))])], 1)]), _vm._v(" "), (_vm.errormsg) ? _c('div', {
    staticClass: "fecshop_message"
  }, [_c('div', {
    staticClass: "error-msg"
  }, [_c('div', [_vm._v("\n                    " + _vm._s(_vm.errormsg) + "\n                ")])])]) : _vm._e(), _vm._v(" "), (_vm.correctmsg) ? _c('div', {
    staticClass: "fecshop_message"
  }, [_c('div', {
    staticClass: "correct-msg"
  }, [_c('div', [_vm._v("\n                    " + _vm._s(_vm.correctmsg) + "\n                ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "list-block customer-login  customer-register"
  }, [_c('div', {
    attrs: {
      "id": "form-validate",
      "autocomplete": "off"
    }
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "input-text required-entry",
    staticStyle: {
      "color": "#ccc"
    },
    attrs: {
      "type": "text",
      "placeholder": "Email Address",
      "readonly": "true",
      "id": "customer_email",
      "name": "editForm[email]",
      "title": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstname),
      expression: "firstname"
    }],
    staticClass: "input-text required-entry",
    attrs: {
      "placeholder": "First name",
      "id": "firstname",
      "name": "editForm[firstname]",
      "title": "First Name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "validation-advice",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "required_current_firstname"
    }
  }, [_vm._v("This is a required field.")])])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastname),
      expression: "lastname"
    }],
    staticClass: "input-text required-entry",
    attrs: {
      "type": "text",
      "placeholder": "Last name",
      "id": "lastname",
      "name": "editForm[lastname]",
      "title": "Last Name",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "validation-advice",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "required_current_lastname"
    }
  }, [_vm._v("<?= Yii::$service->page->translate->__('This is a required field.');?>")])])])])]), _vm._v(" "), _c('li', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "change_password_label item-content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.change_password_is_checked),
      expression: "change_password_is_checked"
    }],
    staticClass: "checkbox",
    attrs: {
      "name": "editForm[change_password]",
      "id": "change_password",
      "title": "Change Password",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.change_password_is_checked) ? _vm._i(_vm.change_password_is_checked, null) > -1 : (_vm.change_password_is_checked)
    },
    on: {
      "click": function($event) {
        return _vm.setPasswordForm()
      },
      "change": function($event) {
        var $$a = _vm.change_password_is_checked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.change_password_is_checked = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.change_password_is_checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.change_password_is_checked = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "change_password"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("message.change_password")) + "\n                            ")])])]), _vm._v(" "), (_vm.change_password) ? _c('li', {
    staticClass: "fieldset_pass"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_password),
      expression: "current_password"
    }],
    staticClass: "input-text required-entry",
    attrs: {
      "placeholder": "current password",
      "title": "Current Password",
      "name": "editForm[current_password]",
      "id": "current_password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.current_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.current_password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "validation-advice",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "required_current_password"
    }
  }, [_vm._v("This is a required field")])])])])]) : _vm._e(), _vm._v(" "), (_vm.change_password) ? _c('li', {
    staticClass: "fieldset_pass"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_password),
      expression: "new_password"
    }],
    staticClass: "input-text validate-password required-entry",
    attrs: {
      "placeholder": "New password",
      "title": "New Password",
      "name": "editForm[password]",
      "id": "password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.new_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new_password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "validation-advice",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "required_new_password"
    }
  }, [_vm._v("<?= Yii::$service->page->translate->__('This is a required field.');?>")])])])])]) : _vm._e(), _vm._v(" "), (_vm.change_password) ? _c('li', {
    staticClass: "fieldset_pass"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirm_new_password),
      expression: "confirm_new_password"
    }],
    staticClass: "input-text validate-cpassword required-entry",
    attrs: {
      "placeholder": "Confirm New Password",
      "title": "Confirm New Password",
      "name": "editForm[confirmation]",
      "id": "confirmation",
      "type": "password"
    },
    domProps: {
      "value": (_vm.confirm_new_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirm_new_password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "validation-advice",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "required_confirm_password"
    }
  }, [_vm._v("This is a required field.")])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "buttons-set"
  }, [_c('p', [_c('a', {
    staticClass: "button button-fill",
    attrs: {
      "href": "javascript:void(0)",
      "id": "js_editBtn"
    },
    on: {
      "click": function($event) {
        return _vm.editAccountInfo()
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t("message.edit_account")) + "\n                            \n                        ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-name"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-name"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-name"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-name"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-name"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-name"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b3ee704!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/body/customer/Editaccount.vue
// module id = 256
// module chunks = 1